import { FormTemplate } from "components/modal/templates";
import { generatePassword } from "helpers/system";
import React from "react";
import { applyUser } from "sources/organizationEmployees";
import { config, initialState } from "./config";

class AddUserForm extends FormTemplate {
    sendRequest = (stateData) => {
        return applyUser(stateData);
    };

    renderBodyInner = () => {
        const { config } = this.props;
        return (
            <>
                {this.renderField(config.email)}
                {this.renderField(config.password)}
                {this.renderField(config.firstName)}
                {this.renderField(config.lastName)}
                {this.renderField(config.patronymic)}
                {this.renderField(config.phoneNumber)}
                {this.renderField(config.phoneNumberExtension)}
                {this.renderCheckbox(config.sendLoginData)}
            </>
        );
    };
}

const ConfiguredModal = (props) => (
    <AddUserForm
        {...props}
        config={config}
        initialState={{ ...initialState, password: generatePassword(), sendLoginData: true }}
    />
);

export default ConfiguredModal;
